import React, {useEffect, useRef, useState} from "react";

import {Button, Divider, Input, message, Modal} from "antd";
import {useTranslation} from "react-i18next";
import PlanItem from "./PlanItem";
import {IClusterPlanShortItem, TClusterPlanItem} from "../../../api/apiTypes";
import InfiniteList from "../../molecules/list/InfiniteList";
import {showApiError, showMessage,} from "../../../common/message";
import Lottie from "lottie-react";
import spinner from "../../../assets/lotties/spinner.json";
import http from "../../../services/http.service";
import {queries} from "../../../api/queries";
import {SearchParams} from "./MergePlanPopup";
import {useDebounce} from "../../../services/useDebounce";
import {DraggableModal} from "../../molecules/DraggableModal";

type TUpdatePlanAPIData = {
  tracking_number_list: string[];
  dest_plan_id: number;
  plan_date: string;
  plan_no: string;
};

interface Props {
  trackingNumbers: string[];
  onShifted: () => void;
  onHide: () => void;
  params: SearchParams;
}

export const ShiftPlanPopup = ({
                                 onShifted, onHide, trackingNumbers, params: paramsProp,
                               }: Props) => {
  const [messageApi, messageHolder] = message.useMessage();
  const {t} = useTranslation("shipping");
  const [selectedPlan, selectPlan] = useState<TClusterPlanItem>();
  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState<SearchParams>({
    page_size: 20, ...paramsProp,
  });
  const inputValueRef = useRef("");
  
  useEffect(() => {
    if (paramsProp) setParams((prev) => ({...prev, ...paramsProp}));
  }, [paramsProp]);
  
  const handleShift = (e: any) => {
    if (!!selectedPlan) {
      setIsLoading(true);
      const data: TUpdatePlanAPIData = {
        plan_date: selectedPlan.plan_date,
        plan_no: selectedPlan.plan_no,
        dest_plan_id: selectedPlan.id,
        tracking_number_list: trackingNumbers,
      };
      http
      .post<TUpdatePlanAPIData>(queries.plan.shift, data)
      .then(onShifted)
      .catch((e) => {
        showApiError(e, messageApi);
      })
      .finally(() => {
        setIsLoading(false);
      });
    }
    else {
      showMessage(messageApi, t("Please, select plan to be shifted"));
    }
  };
  
  const debouncedChange = useDebounce((inputValue) => {
    console.log('Debounced:', inputValue);
    setParams((prev) => ({
      ...prev, cluster_id__startswith: inputValueRef.current,
    }));
  }, 1000);
  
  const handleSearch = (e: any) => {
    if (e.target.value) inputValueRef.current = e.target.value;
    debouncedChange(inputValueRef.current);
  };
  
  const buttonNode = (<div className={"footer"}>
    <Button
      type={"text"}
      className={"cancel"}
      onClick={onHide}
    >
      {t("popup.btn.back")}
    </Button>
    <Divider type={"vertical"} className={"divider"} />
    <Button
      type={"text"}
      className={"ok"}
      onClick={handleShift}
    >
      {t("shift plan")}
    </Button>
  </div>);
  
  return (<DraggableModal
    closable={false}
    cancelText={""}
    open={true}
    maskClosable
    centered
    width={335}
    className={"sm-modal"}
    classNames={{body: "body", content: "content", footer: "footer"}}
    footer={buttonNode}
  >
    {messageHolder}
    <div className={"title"}>
      {t("shift plan")}
    </div>
    <Input
      onChange={handleSearch}
      size={"small"}
      className={"input"}
      placeholder={t("search plan")}
      autoComplete={"off"}
      suffix={<Button
        type={"text"}
        size={"small"}
        color={"primary"}
        onClick={handleSearch}
        className={"button"}
      >
        {t("search")}
      </Button>}
    />
    <InfiniteList<IClusterPlanShortItem>
      url={queries.plan.short}
      params={params}
      height={300}
      itemSize={46}
      renderItem={(plan, style) => (<PlanItem
        key={"rider" + plan.id}
        selected={plan.id === selectedPlan?.id}
        plan={plan}
        style={style}
        onSelect={selectPlan}
      />)} />
    {isLoading && (<div className={"spinner"}>
      <Lottie animationData={spinner} autoplay loop style={{height: 25}} />
    </div>)}
  </DraggableModal>);
};
